import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { $academy } from '../../../../../../shared/constants/academy';
import { $tenant, $tenantUser, $tenantUserIntegrations } from '../../../../../../shared/constants/tenant';

import { ITenantUser, ITenant } from '../../../../../../shared/interfaces/tenant.interface';
import { TenantService } from '../../../../services/tenant.service';
import { AngularUtility } from '../../../../utility/angular.utility';

@Component({
  selector: 'app-tenant-tab-academy',
  templateUrl: './tenant-tab-academy.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TenantTabAcademyComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private seatLimit: number;

  @Input()
  public tenant$: Observable<ITenant>;
  public tenantUsers$: Observable<ITenantUser[]>;
  public requestUsersReload$: BehaviorSubject<unknown>;

  public seatsRemaining: number;
  public seatsTaken: number;

  constructor(
    private tenantService: TenantService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.subscription = new Subscription();
    this.requestUsersReload$ = new BehaviorSubject<unknown>(undefined);
    this.seatsTaken = 0;
    this.seatsRemaining = 0;
  }

  public ngOnInit(): void {
    this.tenantUsers$ = combineLatest([this.tenant$, this.requestUsersReload$]).pipe(
      tap(([tenant]: [ITenant, void]) => {
        this.seatLimit = tenant[$tenant.academyConfig][$academy.seatLimit];
      }),
      switchMap(([tenant]: [ITenant, void]) => this.tenantService.getTenantUsers(tenant[$tenant._id])),
      tap((users: ITenantUser[]) => {
        this.seatsTaken = users.filter(
          (u: ITenantUser) => u[$tenantUser.integrations]?.[$tenantUserIntegrations.academy]?.enabled,
        ).length;

        this.seatsRemaining = Math.max(this.seatLimit - this.seatsTaken, 0);

        this.changeDetectorRef.detectChanges();
      }),
      AngularUtility.shareRef<ITenantUser[]>(),
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
